import React from 'react';
import { UploadedFilesSectionProps } from './FrameListPanel.types';
import { UploadedFileItem } from './UploadedFileItem';

export const UploadedFilesSection: React.FC<UploadedFilesSectionProps> = ({
  uploadedListOfFiles,
  openCategories,
  onToggleCategory,
  handleFileToggle,
  handleFrameToggleInFile,
}) => {
  if (!uploadedListOfFiles.length) return null;

  return (
    <div className="border-t border-neutral-200 py-2">
      <div className="px-4 py-1 text-sm font-medium text-neutral-700">Uploaded Files</div>
      {uploadedListOfFiles.map((file) => (
        <UploadedFileItem
          key={file.name}
          file={file}
          uploadedListOfFiles={uploadedListOfFiles}
          openCategories={openCategories}
          onToggleCategory={onToggleCategory}
          handleFileToggle={handleFileToggle}
          handleFrameToggleInFile={handleFrameToggleInFile}
        />
      ))}
    </div>
  );
};
